import AppointmentBooking from "@/pages/epc/BookPage.vue";


export default [

  {
    path: '/epc/booking/',
    component: AppointmentBooking,
    props: true
  }
]
